import axios from 'axios';

export default {
  state: {
    certificate: {},
    loading: false,
    error: null,
    certificateLoaded: false,
    certificateLoading: false
  },
  mutations: {
    SET_CERTIFICATE(state, certificate) {
      state.certificate = certificate.data;
      state.certificateLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_CERTIFICATE_LOADING(state, status) {
      state.certificateLoading = status;
    },
    SET_CERTIFICATE_ERROR(state, error) {
      state.certificateError = error;
    },
    UNSET_CERTIFICATE(state) {
      state.certificateLoaded = false;
      state.certificateLoading = false;
      state.certificate = [];
    },
  },
  actions: {
    async fetchCertificate({ commit, state }) {
      if (state.loaded && state.certificate.length > 0) {
        return; // Если данные уже загружены, прекращаем выполнение
      }
      try {
        commit('SET_CERTIFICATE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/certificate/');
        commit('SET_CERTIFICATE', response.data);
        commit('SET_CERTIFICATE_ERROR', null);
      } catch (error) {
        commit('SET_CERTIFICATE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching certificate:', error);
      } finally {
        commit('SET_CERTIFICATE_LOADING', false);
      }
    }
  },
  getters: {
    certificate: state => state.certificate,
    certificateLoading: state => state.certificateLoading,
    certificateError: state => state.certificateError,
    certificateLoaded: state => state.certificateLoaded
  }
}